import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues } from 'redux-form'
import ReactTable from 'react-table'
import { StdForm } from 'components'
import { DetailContainer, Cont, SContDetail, BLContainer } from './styled'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { blInvoiceColumns, blItemColumns } from './data'

const BillingDetail = (props) => {
  const { blDetail, valueForm } = props
  const items = blDetail.billInvoices || []

  const getVendorNameOptions = () => {
    let x = props.vendors.data.find(x => x.value === valueForm.vendorCode)
    if (x) return props.vendors.data
    else {
      let y = [...props.vendors.data]
      y.push({ key: valueForm.vendorCode, value: valueForm.vendorCode, text: valueForm.vendorName })
      return y
    }
  }

  React.useEffect(()=>{
    let expandedRows = {}; 
    items.forEach((i, index) => expandedRows[index]=true )
    setExpanded(expandedRows)
  },[blDetail.billInvoices])
  const [expanded, setExpanded] = React.useState({});

  return (
    <StdForm showHeader={false} title='' >
      <BLContainer >
        <div className='rowFields'>
          <Field
            name='vendorCode'
            label={<span>Vendor name<span style={{ marginLeft: '0.5rem', fontSize: '1.2rem', color: '#FBBF66' }}>{(valueForm && (valueForm.vendorCode.startsWith('9') || valueForm.vendorCode.startsWith('6'))) ? 'บริษัทในเครือ กลุ่มบริษัทดีทีจีโอ' : ''}</span></span>}
            className='halfRow'
            type={type.select}
            options={getVendorNameOptions()}
            loading={props.vendors.loading}
            editable={false}
            component={FieldInput}
          />
        </div>
        <div className='rowFields'>
          <Field
            name='vendorAddress'
            label='Address'
            className='halfRow'
            type={type.text}
            editable={false}
            component={FieldInput}
          />
        </div>
        <Field
          name='vendorTax'
          label='Tax ID'
          className='halfRow'
          type={type.text}
          editable={false}
          component={FieldInput}
        />
      </BLContainer>
      <DetailContainer>
        <Cont style={{ width: '100%' }}>
          <SContDetail>
            <ReactTable
              style={{maxWidth: '100%', overflowX: 'auto'}}
              className='blItems'
              data={items}
              columns={blInvoiceColumns}
              minRows={items.length > 10 ? 10 : items.length || 1}
              defaultPageSize={10}
              showPagination={items.length > 10}
              expanded={expanded}
              onExpandedChange={(expanded, index, event) => {
                setExpanded(expanded);
              }}
              SubComponent={row => {
                return (
                  <div style={{ padding: '10px' }}>
                    <ReactTable
                      data={row.original.billingItems}
                      columns={blItemColumns}
                      minRows={row.original.billingItems.length > 10 ? 10 : row.original.billingItems.length}
                      defaultPageSize={10}
                      showPagination={row.original.billingItems.length > 10}
                    />
                  </div>
                );
              }}
            />

          </SContDetail>
        </Cont>
      </DetailContainer>
      <br />
      <Field
        name='remark'
        label='Remark :'
        type={type.textArea}
        component={FieldInput}
        editable={false}
      />
    </StdForm >
  )
}

const mapStateToProps = state => {
  const valueForm = getFormValues('formBill')(state) || {}
  var projectOptions = []
  if (valueForm.companyCode && state.goa.projects && state.goa.projects[valueForm.companyCode]) {
    projectOptions = state.goa.projects[valueForm.companyCode].map(p => {
      return { value: p.id, text: p.projectName }
    })

    if (state.goa.projects.other) {
      state.goa.projects.other.forEach(p => {
        projectOptions.push({ value: p.id, text: p.projectName })
      })
    }
  }
  return {
    blDetail: state.billform.billformDetail.data,
    members: state.member.members,
    vendors: state.options.vendors,
    valueForm
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(BillingDetail)
